<template>
    <div class="main-page">
        <div class="mx-auto flex-auto w-full min-h-0 flex flex-col page-content" :class="contentPageClass">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent } from 'vue';

export default defineComponent({
    props: {
        bgColor: {
            type: String,
            default: "white"
        }
    },
    setup: function (props) {
        const contentPageClass = computed(() => {
            return "bg-color-" + props.bgColor
        })

        return {
            contentPageClass
        }
    }
})
</script>

<style lang="scss" scoped>
.main-page {
    @apply mx-auto flex flex-col w-full min-h-screen font-main max-w-lg;

    .page-content {
        &.bg-color-white {
            @apply bg-white;
        }

        &.bg-color-gray-a-f1f1f1 {
            @apply bg-a-gray-f1f1f1;
        }
    }
}
</style>